import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'line-with-custom-bullets',
    templateUrl: 'line-with-custom-bullets.component.html',
    styleUrls: ['line-with-custom-bullets.component.css','../../charts.style.scss']
})

export class LineWithCustomBulletsChartComponent implements OnInit, AfterViewInit {
    @Input() chartSpecification: ChartSpecification;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "lineDiv";

        if (typeof this.chartSpecification.parseDates === "undefined") {
            this.chartSpecification.parseDates = true;
        }
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "serial",
                "theme": this.chartSpecification.theme,
                "dataProvider": this.chartSpecification.data,
                "mouseWheelZoomEnabled": false,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "valueAxes": [{
                    "axisAlpha": 0,
                    "gridAlpha": 0,
                    "dashLength": 4,
                    "position": "left",
                    "labelsEnabled": false,
                    "title": this.chartSpecification.yAxisTitle
                }],
                "graphs": [{
                    "bulletSize": 6,
                    "bullet": "round",
                    "precision": 2,
                    "valueField": this.chartSpecification.yAxis,
                    "balloonText": "<div style='margin:2px; text-align:left; font-weight: bold;'><span style='font-size:9px'>[[category]]</span><br><span style='font-size:10px'>Value:[[value]]</span>",
                    "lineColor": this.chartSpecification.chartColor
                }],
                "marginTop": 20,
                "marginRight": 30,
                "marginLeft": 30,
                "marginBottom": 20,
                "chartCursor": {
                    "graphBulletSize": 1.5,
                    "zoomable": false,
                    "valueZoomable": true,
                    "cursorAlpha": 0,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": false,
                    "valueLineAlpha": 0.2
                },
                "autoMargins": false,
                "categoryField": this.chartSpecification.xAxis,
                "chartScrollbar": {
                    "offset": 30,
                    "oppositeAxis": false
                },
                "categoryAxis": {
                    "parseDates": this.chartSpecification.parseDates,
                    "gridAlpha": 0,
                    "tickLength": 0
                },
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/lineCharts/line-with-custom-bullets/line-with-custom-bullets.component.ts